import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import OverlappingDutyTransactions from './OverlappingDutyTransactions';

const OverlappingDutyTransactionsContainer = props => (
  <Provider store={store}>
    <OverlappingDutyTransactions {...props} />
  </Provider>
);

export default OverlappingDutyTransactionsContainer;
